import React from 'react';
import { View, StyleSheet } from 'react-native';
import Modal from './Modal';
import OptionNavigate from './OptionNavigate';
import { CommonProperties } from '../styles';

const NavigateFilter = ({ items = [], onPress, selected, ...rest }) => {
  return (
    <Modal animationType="fade" statusBarTranslucent={false} transparent={true} {...rest}>
      <View style={styles.container}>
        <View style={styles.innerContainer}>
          {items &&
            items?.map((item, index) => {
              return (
                <OptionNavigate
                  style={[styles.row, items.length - 1 === index ? { borderBottomWidth: 0 } : null]}
                  key={item.brand}
                  onPress={() => {
                    onPress(item.brand);
                    rest.onRequestClose();
                  }}
                  icon={item.icon}
                  title={item.name}
                  desc={item.desc}
                  price={item.price}
                  selected={item.brand === selected}
                />
              );
            })}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'rgba(0,0,0,.4)',
    ...StyleSheet.absoluteFillObject,
    ...CommonProperties.p3,
    ...CommonProperties.centerAlignment,
  },
  innerContainer: {
    width: '100%',
    maxWidth: 540,
    backgroundColor: 'white',
    borderRadius: 5,
    ...CommonProperties.py2,
  },
  row: {
    ...CommonProperties.px5,
    ...CommonProperties.py3,
  },
});

export default NavigateFilter;
